import { render, staticRenderFns } from "./multiValueInput.vue?vue&type=template&id=5d3c2212&scoped=true&"
import script from "./multiValueInput.vue?vue&type=script&lang=js&"
export * from "./multiValueInput.vue?vue&type=script&lang=js&"
import style0 from "./multiValueInput.vue?vue&type=style&index=0&id=5d3c2212&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3c2212",
  null
  
)

export default component.exports